export default __webpack_public_path__ + "static/media/notice_trade.30369408.svg";